import { Event } from '../../global/event.js';

export class PaymentOption extends Event {
    constructor(element) {
        super();
        this._element = element;
        this._form = document.querySelector('.payform-' + this._element.dataset.type);
        this.init();
    };
    
    get type() {
        return this._element.dataset.type || null;
    }

    get text() {
        return this._element.dataset.text || '';
    }

    get isSelected() {
        return this._element.classList.contains('active');
    }

    get isVisible() {
        return !this._element.classList.contains('d-none');
    }

    set isFirst(value) {
        if (value) {
            this._element.classList.add('firstOption');
        } else {
            this._element.classList.remove('firstOption');
        }
    }

    set isLast(value) {
        if (value) {
            this._element.classList.add('lastOption');
        } else {
            this._element.classList.remove('lastOption');
        }
    }
    
    init() {
        this._element.addEventListener('click', () => {
            this.select();
        });
    }
    
    select() {
        OVS.app.helper.removeClass('.payoption', 'active');
        OVS.app.helper.addClass('.payform', 'd-none');
        OVS.app.helper.removeClass('.payform', 'zahlungactive');

        this._element.classList.add('active');

        if (this._form) {
            this._form.classList.add('zahlungactive');
            this._form.classList.remove('d-none');
        }

        if(this.type == 'current') {
            OVS.app.helper.addClass('#payment-faktura', 'd-none');
            OVS.app.helper.addClass('#zahlungtop', 'd-none');
        } else {
            OVS.app.helper.removeClass('#payment-faktura', 'd-none');
            OVS.app.helper.removeClass('#zahlungtop', 'd-none');
        }

        this.fireEvent('select', {
            title: this.text,
            type: this.type,
        });
    }
    
    show() {
        this._element.classList.remove('d-none');
    }
    
    hide() {
        this._element.classList.add('d-none');
    }
}
